import axios from 'axios';

export const baseURL = process.env.NEXT_PUBLIC_API;

export const api = axios.create({
  baseURL,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
});

export function useApi() {
  return { api };
}
